<template>
  <div :class="['wrapper', classes]" refs="box-wrapper">
    <header class="main-header" ref="mainHeader">
      <router-link tag="a" to="/" class="logo">
        <!-- mini logo for sidebar mini 50x50 pixels -->
        <span class="logo-mini" style="text-align:center">
          <b>NTI</b>
        </span>
        <!-- logo for regular state and mobile devices -->
        PMVC - CMC
      </router-link>

      <!-- Header Navbar -->
      <nav class="navbar navbar-static-top" role="navigation">
        <!-- Sidebar toggle button-->
        <a href="javascript:;" class="sidebar-toggle" data-toggle="offcanvas" role="button">
          <span class="sr-only">Toggle navigation</span>
        </a>
        <!-- Navbar Right Menu -->
        <div class="navbar-custom-menu">
          <ul class="nav navbar-nav">
            <!-- User Account Menu -->
            <li class="dropdown user user-menu">
              <a href="javascript:;" class="dropdown-toggle" data-toggle="dropdown">
                <!-- The user image in the navbar-->
                <img v-bind:src="user_current.avatar" class="user-image" alt="User Image">
                <!-- hidden-xs hides the username on small devices so only the image appears. -->
                <span class="hidden-xs">{{ user_current.displayName }}</span>
              </a>

              <ul class="dropdown-menu">
                <!-- User image -->
                <li class="user-header">
                  <img v-bind:src="user_current.avatar" class="img-circle" alt="User Image">

                  <p>{{ user_current.displayName }}</p>
                  <p>
                    <strong>{{ user_current.setor }}</strong>
                  </p>
                </li>

                <!-- Menu Footer-->
                <li class="user-footer">
                  <div class="pull-left">
                    <router-link
                      to="/cadastros/usuarios/alterar-senha"
                      class="btn btn-default btn-flat"
                      v-show="this.hasPermission('usuario.updatePassword')"
                    >Alterar Senha</router-link>
                  </div>
                  <div class="pull-right">
                    <a class="btn btn-default btn-flat" @click.prevent="logout()">Sair</a>
                  </div>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </nav>
    </header>
    <!-- Left side column. contains the logo and sidebar -->
    <aside class="main-sidebar" ref="mainSideBar">
      <!-- sidebar: style can be found in sidebar.less -->
      <section class="sidebar">
        <!-- Sidebar Menu -->
        <sidebar-menu/>
        <!-- /.sidebar-menu -->
      </section>
      <!-- /.sidebar -->
    </aside>

    <!-- Content Wrapper. Contains page content -->
    <div class="content-wrapper" :style="{ 'min-height': fullHeight+'px' }">
      <!-- Content Header (Page header) -->
      <section class="content-header">
        <h1>
          CMC
          <small>{{ $route.meta.description }}</small>
        </h1>
      </section>

      <router-view></router-view>
      <!-- Componente chamado na rota é renderizado aqui dentro -->
    </div>
    <!-- /.content-wrapper -->

    <!-- Main Footer -->
    <footer class="main-footer" ref="mainFooter">
      <strong>
        Copyright &copy; {{year}}
        <a href="javascript:void(0)">NTI</a>.
      </strong> Todos os direitos reservados.
    </footer>
  </div>
  <!-- ./wrapper -->
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import config from "../config";
import SidebarMenu from "./SidebarMenu";
import "hideseek";

export default {
  name: "Dash",
  created() {
		if (sessionStorage.getItem('logeed')) {
			sessionStorage.removeItem('logeed')
			this.$router.go(0)
		}
	},
  mounted() {
    let fullHeight =
      window.innerHeight -
      this.$refs.mainFooter.clientHeight -
      this.$refs.mainHeader.clientHeight -
      2;
    let sideBarHeight = this.$refs.mainSideBar.clientHeight;
    if (sideBarHeight > fullHeight) {
      this.fullHeight = sideBarHeight - this.$refs.mainHeader.clientHeight - 2;
    } else {
      this.fullHeight = fullHeight;
    }
    this.$store.state.definiuTamanhoTela = true;

    this.getUserCurrent();
  },
  data: function() {
    return {
      section: "Dash",
      logo: `${this.$store.state.serverURI}/images/almox-logo.png`,
      year: new Date().getFullYear(),
      classes: {
        fixed_layout: config.fixedLayout,
        hide_logo: config.hideLogoOnMobile
      },
      error: "",
      fullHeight: "",
      userCurrent: {
        id: null,
        name: null,
        email: null,
        setor: null
      }
    };
  },
  computed: {
    ...mapState(["userInfo"]),
    user_current() {
      return {
        id: this.userCurrent.id,
        displayName: this.userCurrent.name,
        avatar: `${this.$store.state.serverURI}/images/default-avatar.png`,
        email: this.userCurrent.email,
        setor: this.userCurrent.setor
      };
    }
  },
  methods: {
    getUserCurrent() {
      axios
        .get(
          `${this.$store.state.serverURI}/api/usuario/getUserCurrent`,
          this.$store.getters.getHeaderAuth
        )
        .then(response => {
          this.userCurrent = response.data;
          this.setUsuarioAtual(this.userCurrent);
        })
        .catch(error => {
          console.log(error);
        });
    },
    changeloading() {
      this.$store.commit("TOGGLE_SEARCHING");
    }
  },
  components: {
    SidebarMenu
  }
};
</script>

<style lang="scss">
html,
body {
  height: 100%;
  background-color: white;
}

.wrapper.fixed_layout {
  .main-header {
    position: fixed;
    width: 100%;
  }

  .content-wrapper {
    padding-top: 50px;
  }

  .main-sidebar {
    position: fixed;
    height: 100vh;
  }
}

.wrapper.hide_logo {
  @media (max-width: 767px) {
    .main-header .logo {
      display: none;
    }
  }
}

.logo-mini,
.logo-lg {
  text-align: left;

  img {
    padding: 0.4em !important;
  }
}

.logo-lg {
  img {
    display: -webkit-inline-box;
    width: 25%;
  }
}
.user-panel {
  height: 4em;
}

hr.visible-xs-block {
  width: 100%;
  background-color: rgba(0, 0, 0, 0.17);
  height: 1px;
  border-color: transparent;
}

.skin-blue .main-header .navbar {
  background-color: #22487b;
}

.skin-blue .main-header .logo {
  background-color: #22487b;
}

.skin-blue .main-header li.user-header {
  background-color: #22487b;
}
input,
select {
  text-transform: uppercase !important;
}
table td {
  text-transform: uppercase;
}
.v-select .dropdown-menu > li > a{
    text-transform: uppercase !important;
}
</style>



// WEBPACK FOOTER //
// Dash.vue?73b4d068